class TileLayers {
  zoomCanvases: Map<number, HTMLCanvasElement>;

  currentZoomLevel: number;

  constructor(zoomCanvases: Map<number, HTMLCanvasElement>) {
    this.zoomCanvases = zoomCanvases;
    this.currentZoomLevel = 1;
  }
}

export default TileLayers;
